import React from 'react';
import EntityTagPickerSingle from './EntityTagPickerSingle';
import TagsManage from "Modules/.common/components/TagsManage";

/**
 * Router component that renders content based on option: "all" (message), "entities" (Single), or "tags" (TagsManage)
 */
const ContentArea = ({
    option,
    entity,
    messages,
    searchText,
    setSearchText,
    data,
    total,
    values,
    onChange,
    disabled,
    onOpen,
    hiddenCheckbox,
    includeInactiveDrivers
}) => {
    // Render "all" option message
    if (option?.id === "all") {
        return (
            <span className='text-muted'>
                {messages[`entityUnitDriverSelector_all${entity?.id}Selected`]}
            </span>
        );
    }

    // Render "entities" option with Single component
    if (option?.id === "entities") {
        return (
            <EntityTagPickerSingle
                searchText={searchText}
                setSearchText={setSearchText}
                data={data}
                values={values}
                onChange={onChange}
                entity={entity}
                disabled={disabled}
                onOpen={onOpen}
                hiddenCheckbox={hiddenCheckbox}
                includeInactiveDrivers={includeInactiveDrivers}
            />
        );
    }

    // Render "tags" option with TagsManage component
    if (option?.id === "tags") {
        return (
            <TagsManage
                enableSelectAll
                multiple
                messages={messages}
                value={values}
                onChange={(value) => {
                    onChange(value);
                }}
                hideTagsWithoutEntities
                mode="selector"
                menuStyle={{
                    width: window.innerWidth > 1400 ? 333 : 319,
                    maxHeight: 360,
                    paddingTop: "15px",
                }}
                isVisiblePill
                onlyTags
            />
        );
    }

    return null;
};

export default ContentArea;

